module.exports = __webpack_public_path__ + "img/logo-davidoff.190637ce.png";